export default __webpack_public_path__ + "static/media/Spring21_05.b8b83e4c.png";